module.exports = __webpack_public_path__ + "img/a2.48ad59f4.jpg";